
import { defineComponent } from 'vue';

import FormField from '@/components/forms/FormField.vue';

/**
 * TODO:
 *
 * Recreate this component when the backend start creating auto-generated
 * passwords
 */

export default defineComponent({
  name: 'placeholder-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      default: 'w-100',
      type: String,
    },
    name: {
      default: 'placeholder',
      type: String,
    },
    label: {
      default: 'Insert Placeholder',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    options: {
      default: () => {
        return [];
      },
      type: Array,
    },
    selectPlaceholder: {
      default: `Insert Placeholder`,
      type: String,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },
  },
});
